import {
  GET_SOURCE_SETTINGS_STICKY_COLUMNS,
  GET_SOURCE_SETTINGS_STICKY_COLUMNS_SUCCESS,
  GET_SOURCE_SETTINGS_STICKY_COLUMNS_ERROR,
  UPDATE_SOURCE_SETTING_STICKY_COLUMNS,
  UPDATE_SOURCE_SETTING_STICKY_COLUMNS_SUCCESS,
  UPDATE_SOURCE_SETTING_STICKY_COLUMNS_ERROR,
  GET_LEAD_SOURCE_SETTINGS_STICKY_COLUMNS,
  GET_LEAD_SOURCE_SETTINGS_STICKY_COLUMNS_SUCCESS,
  GET_LEAD_SOURCE_SETTINGS_STICKY_COLUMNS_ERROR,
  UPDATE_LEAD_SOURCE_SETTINGS_STICKY_COLUMNS,
  UPDATE_LEAD_SOURCE_SETTINGS_STICKY_COLUMNS_SUCCESS,
  UPDATE_LEAD_SOURCE_SETTINGS_STICKY_COLUMNS_ERROR,
  UPDATE_CALL_SOURCE_SETTINGS_STICKY_COLUMNS,
  UPDATE_CALL_SOURCE_SETTINGS_STICKY_COLUMNS_SUCCESS,
  UPDATE_CALL_SOURCE_SETTINGS_STICKY_COLUMNS_ERROR,
  GET_CALL_SOURCE_SETTINGS_STICKY_COLUMNS,
  GET_CALL_SOURCE_SETTINGS_STICKY_COLUMNS_SUCCESS,
  GET_CALL_SOURCE_SETTINGS_STICKY_COLUMNS_ERROR
} from "./actionTypes"

// FOR GET ADMIN USER ROLE
export const getSourceSettingStickyColumns = () => {
  return {
    type: GET_SOURCE_SETTINGS_STICKY_COLUMNS,
  }
}

export const getSourceSettingStickyColumnsSuccess = sticky_columns => {
  return {
    type: GET_SOURCE_SETTINGS_STICKY_COLUMNS_SUCCESS,
    payload: sticky_columns,
  }
}

export const getSourceSettingStickyColumnsError = error => {
  return {
    type: GET_SOURCE_SETTINGS_STICKY_COLUMNS_ERROR,
    payload: error,
  }
}

// FOR UPDATE ADMIN USER ROLE
export const updateSourceSettingStickyColumns = (sticky_columns) => {
  return {
    type: UPDATE_SOURCE_SETTING_STICKY_COLUMNS,
    payload: sticky_columns,
  }
}

export const updateSourceSettingStickyColumnsSuccess = sticky_columns => {
  return {
    type: UPDATE_SOURCE_SETTING_STICKY_COLUMNS_SUCCESS,
    payload: sticky_columns,
  }
}

export const updateSourceSettingStickyColumnsError = error => {
  return {
    type: UPDATE_SOURCE_SETTING_STICKY_COLUMNS_ERROR,
    payload: error,
  }
}

// Lead Source Settings
export const getLeadSourceSettingStickyColumns = () => {
  return {
    type: GET_LEAD_SOURCE_SETTINGS_STICKY_COLUMNS,
  }
}

export const getLeadSourceSettingStickyColumnsSuccess = sticky_columns => {
  return {
    type: GET_LEAD_SOURCE_SETTINGS_STICKY_COLUMNS_SUCCESS,
    payload: sticky_columns,
  }
}

export const getLeadSourceSettingStickyColumnsError = error => {
  return {
    type: GET_LEAD_SOURCE_SETTINGS_STICKY_COLUMNS_ERROR,
    payload: error,
  }
}

// FOR UPDATE ADMIN USER ROLE
export const updateLeadSourceSettingStickyColumns = (sticky_columns) => {
  return {
    type: UPDATE_LEAD_SOURCE_SETTINGS_STICKY_COLUMNS,
    payload: sticky_columns,
  }
}

export const updateLeadSourceSettingStickyColumnsSuccess = sticky_columns => {
  return {
    type: UPDATE_LEAD_SOURCE_SETTINGS_STICKY_COLUMNS_SUCCESS,
    payload: sticky_columns,
  }
}

export const updateLeadSourceSettingStickyColumnsError = error => {
  return {
    type: UPDATE_LEAD_SOURCE_SETTINGS_STICKY_COLUMNS_ERROR,
    payload: error,
  }
}

//Call Source Settings
export const getCallSourceSettingStickyColumns = () => {
  return {
    type: GET_CALL_SOURCE_SETTINGS_STICKY_COLUMNS,
  }
}

export const getCallSourceSettingStickyColumnsSuccess = sticky_columns => {
  return {
    type: GET_CALL_SOURCE_SETTINGS_STICKY_COLUMNS_SUCCESS,
    payload: sticky_columns,
  }
}

export const getCallSourceSettingStickyColumnsError = error => {
  return {
    type: GET_CALL_SOURCE_SETTINGS_STICKY_COLUMNS_ERROR,
    payload: error,
  }
}

// FOR UPDATE ADMIN USER ROLE
export const updateCallSourceSettingStickyColumns = (sticky_columns) => {
  return {
    type: UPDATE_CALL_SOURCE_SETTINGS_STICKY_COLUMNS,
    payload: sticky_columns,
  }
}

export const updateCallSourceSettingStickyColumnsSuccess = sticky_columns => {
  return {
    type: UPDATE_CALL_SOURCE_SETTINGS_STICKY_COLUMNS_SUCCESS,
    payload: sticky_columns,
  }
}

export const updateCallSourceSettingStickyColumnsError = error => {
  return {
    type: UPDATE_CALL_SOURCE_SETTINGS_STICKY_COLUMNS_ERROR,
    payload: error,
  }
}

